import React, { useState, useEffect } from 'react';
import { useDebounce } from '../hooks/useDebounce';
import styles from './SearchBox.module.scss';

/**
 * Search box component with debouncing
 * Delays search until user stops typing (300ms)
 *
 * @param {Object} props
 * @param {string} props.value - Current search value
 * @param {Function} props.onChange - Callback when debounced value changes
 */
export default function SearchBox({ value, onChange }) {
    const [localValue, setLocalValue] = useState(value);
    const debouncedValue = useDebounce(localValue, 300);

    // Update parent when debounced value changes
    useEffect(() => {
        onChange(debouncedValue);
    }, [debouncedValue, onChange]);

    // Sync with external value changes
    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    return (
        <div className={styles.searchbox}>
            <input
                type="search"
                name="q"
                placeholder="Produkte suchen ..."
                value={localValue}
                onChange={(e) => setLocalValue(e.target.value)}
            />
            <button type="button" title="Suchen">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
                    <path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                </svg>
            </button>
        </div>
    );
}
